export default class Interval {
    private readonly start: number;
    private readonly end: number;

    constructor(start: number, end: number) {
        this.start = start;
        this.end = end;
    }

    public contains(number: number): boolean {
        return this.start <= number && number <= this.end;
    }

    public static get default() {
        return new Interval(Number.NEGATIVE_INFINITY, Number.POSITIVE_INFINITY);
    }

    public equals(interval: Interval): boolean {
        return this.start == interval.start && this.end == interval.end;
    }
}
